import React, { createContext, Dispatch, ReactNode, useContext, useReducer } from 'react'

interface ProfileState {
  isManageMode: boolean
  isFollowMenuOpen: boolean
  isEditProfileMode: boolean
  isSocialRelationsOpen: boolean
  isAvatarCropperOpen: boolean
  isCoverCropperOpen: boolean
  cropperFilePreviewUrl?: string
}
export enum ProfileReducerActionTypesEnum {
  SET_MANAGE_MODE = 'SET_MANAGE_MODE',
  SET_FOLLOW_MENU_OPEN = 'SET_FOLLOW_MENU_OPEN',
  SET_EDIT_PROFILE_MODE = 'SET_EDIT_PROFILE_MODE',
  SET_SOCIAL_RELATIONS_OPEN = 'SET_SOCIAL_RELATIONS_OPEN',
  SET_AVATAR_CROPPER_OPEN = 'SET_AVATAR_CROPPER_OPEN',
  SET_COVER_CROPPER_OPEN = 'SET_COVER_CROPPER_OPEN',
  SET_CROPPER_FILE_PREVIEW_URL = 'SET_CROPPER_FILE_PREVIEW_URL',
  RESET = 'RESET',
}
type ProfileAction =
  | { type: ProfileReducerActionTypesEnum.SET_MANAGE_MODE; payload: boolean }
  | { type: ProfileReducerActionTypesEnum.SET_FOLLOW_MENU_OPEN; payload: boolean }
  | { type: ProfileReducerActionTypesEnum.SET_EDIT_PROFILE_MODE; payload: boolean }
  | { type: ProfileReducerActionTypesEnum.SET_SOCIAL_RELATIONS_OPEN; payload: boolean }
  | { type: ProfileReducerActionTypesEnum.SET_AVATAR_CROPPER_OPEN; payload: boolean }
  | { type: ProfileReducerActionTypesEnum.SET_COVER_CROPPER_OPEN; payload: boolean }
  | { type: ProfileReducerActionTypesEnum.SET_CROPPER_FILE_PREVIEW_URL; payload?: string }
  | { type: ProfileReducerActionTypesEnum.RESET }

function profileReducer(state: ProfileState, action: ProfileAction): ProfileState {
  switch (action.type) {
    case ProfileReducerActionTypesEnum.SET_MANAGE_MODE:
      return { ...state, isManageMode: action.payload }
    case ProfileReducerActionTypesEnum.SET_FOLLOW_MENU_OPEN:
      return { ...state, isFollowMenuOpen: action.payload }
    case ProfileReducerActionTypesEnum.SET_EDIT_PROFILE_MODE:
      return { ...state, isEditProfileMode: action.payload }
    case ProfileReducerActionTypesEnum.SET_SOCIAL_RELATIONS_OPEN:
      return { ...state, isSocialRelationsOpen: action.payload }
    case ProfileReducerActionTypesEnum.SET_AVATAR_CROPPER_OPEN:
      return { ...state, isAvatarCropperOpen: action.payload }
    case ProfileReducerActionTypesEnum.SET_COVER_CROPPER_OPEN:
      return { ...state, isCoverCropperOpen: action.payload }
    case ProfileReducerActionTypesEnum.SET_CROPPER_FILE_PREVIEW_URL:
      return { ...state, cropperFilePreviewUrl: action.payload }
    case ProfileReducerActionTypesEnum.RESET:
      return initialState
    default:
      throw new Error('Unhandled action type')
  }
}
const initialState = {
  isManageMode: false,
  isFollowMenuOpen: false,
  isEditProfileMode: false,
  isSocialRelationsOpen: false,
  isAvatarCropperOpen: false,
  isCoverCropperOpen: false,
  cropperFilePreviewUrl: '',
}

interface TProfileContextType {
  state: ProfileState
  dispatch: Dispatch<ProfileAction>
}

const ProfileContext = createContext<TProfileContextType | undefined>(undefined)

export const ProfileProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(profileReducer, initialState)

  return <ProfileContext.Provider value={{ state, dispatch }}>{children}</ProfileContext.Provider>
}

export const useProfileContext = () => {
  const context = useContext(ProfileContext)
  if (!context) {
    throw new Error('useProfileContext must be used within a ProfileProvider')
  }
  return context
}
